<InactivityModal />

<!-- App shell: navbar + sidebar fixed; only content scrolls -->
<div class="vh-100 d-flex flex-column bg-gray overflow-hidden">

  <!-- Navbar (same component & behavior) -->
  <Navbar @sidebar-toggle="toggleSidebar"
    class="navbar navbar-expand-lg sticky-top bg-white border-bottom w-100 p-0 m-0">
  </Navbar>

  
  <Sidebar variant="mobile" offcanvas_id="dashboardSidebarOffcanvas" />
<!-- Main area below navbar fills remaining height -->
  <div class="container-fluid flex-grow-1 overflow-hidden">
    <div class="row h-100">

      <!-- Sidebar column (same Sidebar component; no scrolling) -->
      <div class="col-auto bg-white h-100 d-none d-lg-block rounded-end mt-2">
        <div class="mt-2">
          <Sidebar ref="sidebar"></Sidebar>
        </div>
      </div>

      <!-- Content column (the ONLY scrollable area) -->
      <div class="col h-100 overflow-auto mt-2">
        <!-- Actions header (sticky within scrollable content) -->

        <!-- Table body -->
        <div class="visitor-card shadow border-primary">
          <div class="card-body bg-white pt-2">
         
          <div class="d-flex align-items-center sticky-top mb-4">
            <button
              class="btn btn-light border rounded-circle d-inline-flex d-lg-none align-items-center justify-content-center p-0 dashboard-workspace-menu me-2"
              type="button"
              data-bs-toggle="offcanvas"
              data-bs-target="#dashboardSidebarOffcanvas"
              aria-controls="dashboardSidebarOffcanvas"
              aria-label="Open workspace menu"
            >
              <i class="bx bx-menu-alt-left fs-5"></i>
            </button>

            <div class="ms-auto">
              <button
                v-can-create="'portals'"
                class="btn btn-primary btn-sm rounded-3 shadow-sm lh-sm"
                @click="openCreateModal"
              >
                <span class="small text-xs d-flex align-items-center gap-1">
                  Create Portal
                </span>
              </button>
            </div>
          </div>

            <div class="row g-2 mb-3">
              <div
                v-for="card in portal_dashboard_cards"
                :key="card.label"
                class="col-6 col-md-4 col-xl"
              >
                <div class="dashboard-summary-card border rounded bg-white p-3 h-100 shadow-sm">
                  <div class="d-flex align-items-start justify-content-between gap-3 h-100">
                    <div class="d-flex flex-column justify-content-between h-100 min-w-0">
                      <div class="text-muted text-xxs fw-bold text-uppercase text-truncate">{{ card.label }}</div>
                      <div class="fw-bold text-dark h4 mb-0 mt-2">{{ card.value }}</div>
                    </div>
                    <span
                      class="portal-dashboard-card-icon rounded-circle d-inline-flex align-items-center justify-content-center bg-light border flex-shrink-0"
                    >
                      <i class="bi" :class="[`text-${card.tone}`, card.icon]"></i>
                    </span>
                  </div>
                </div>
              </div>
            </div>

            <!-- table -->
            <div v-show="isLoading" class="text-center py-5 w-100">
              <div class="spinner-border text-secondary" role="status">
                <span class="visually-hidden">Loading...</span>
              </div>
              <p class="mt-2 mb-0 text-muted text-xxs">Loading Portal List...</p>
            </div>
            <div v-show="!isLoading">
              <div class="table-responsive">
                <table id="portal-table" class="table align-middle table-striped table-borderless">
                  <thead class="btn-primary text-white ">
                    <tr>
                      <th class="text-xxs fw-light">No.</th>
                      <th class="text-xxs fw-light text-start">Portal Name</th>
                      <th class="text-xxs fw-light text-start">Portal Type</th>
                      <th class="text-xxs fw-light text-start">Is Privacy</th>
                      <th class="text-xxs fw-light text-start">Is Visible</th>
                      <th class="text-xxs fw-light text-start">Actions</th>
                    </tr>
                  </thead>

                  <tbody>
                    <!-- Apply text-xxs at the row level for all cells -->
                    <tr v-for="(portal, index) in portals" :key="portal.id" class="border-bottom text-xxs">
                      <!-- Number -->
                      <td class="text-start">
                          {{ index + 1 }}
                      </td>

                      <!-- Portal Name -->
                      <td>
                        <div class="text-xxs">{{ portal.name }}</div>
                      </td>

                      <!-- Type -->
                      <td class="text-start">
                        <span class="text-xxs">
                          {{ portal.portal_type?.name || '—' }}
                        </span>
                      </td>

                      <!-- Privacy -->
                      <td class="text-start">
                          <span class="text-xxs">{{ portal.is_public ? 'Public' : 'Private' }}</span>
                      </td>
                      <!-- Visibility -->
                      <td class="text-start">
                          <span class="text-xxs">{{ (portal.is_visible === true || portal.is_visible === 'true') ?
                            'Visible' : 'Hidden' }}</span>
                      </td>

                      <!-- Actions -->
                      <td class="text-start">
                        <div class="d-flex justify-content-center gap-1">
                          <router-link :to="'manage_portal/' + portal.id + '/'+ portal.portal_type.name"
                            class="btn btn-light btn-sm rounded-3 text-primary border">
                            <span class="text-xxs">View</span>
                          </router-link>

                          <button class="btn btn-light btn-sm rounded-3 text-success border"
                            @click="openEditModal(portal)">
                            <span class="text-xxs">Edit</span>
                          </button>

                          <button class="btn btn-light btn-sm rounded-3 text-danger border"
                            @click="deletePortal(portal.id)">
                            <span class="text-xxs">Delete</span>
                          </button>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div> <!-- /table-responsive -->
            </div> <!-- /card-body -->
          </div>
        </div>

      </div> <!-- /col content -->

    </div> <!-- /row -->
  </div> <!-- /container-fluid -->

</div> <!-- /app shell -->


<!-- Create / Edit Portal Modal -->
<div class="modal fade" id="create_portal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-lg modal-dialog-scrollable">
    <div class="modal-content">
      <div class="modal-header bg-primary text-white position-relative">
        <p class="modal-title text-center text-xxs fw-500 mb-0 w-100" id="exampleModalLabel">
          {{ isEditMode ? 'Edit Portal' : 'Create a Portal' }}
        </p>

        <!-- Close button on the end with white "X" -->
        <button type="button" class="btn-close btn-close-white position-absolute end-0 top-50 translate-middle-y me-2"
          data-bs-dismiss="modal" aria-label="Close">
        </button>

      </div>
      <form @submit.prevent="createPortal">
        <div class="modal-body modal-body-scroll">

          <!-- Portal Name -->
          <div class="mb-3">
            <label for="portal_name" class="form-label text-xxs fw-500">Portal Name <span
                class="text-danger">*</span></label>
            <input type="text" class="form-control rounded-3 text-xxs" id="portal_name" placeholder="Enter portal name"
              v-model="portal_name">
            <p v-if="errors.portal_name" class="text-danger text-xxs">{{ errors.portal_name }}</p>
          </div>

          <!-- Incident Contact Email -->
          <div v-if="selectedPortalType && selectedPortalType.name === 'incident'">
            <div class="mb-3">
              <label for="contact_email" class="form-label text-xxs fw-500">Authority Email</label>
              <input type="email" id="contact_email" class="form-control rounded-5 text-xxs" v-model="contactEmail">
              <p v-if="errors.contact_email" class="text-danger text-xxs">{{ errors.contact_email }}</p>
            </div>
          </div>

          <!-- Engagement Specific Fields -->
          <div
            v-if="selectedPortalType && (selectedPortalType.name === 'engagement' || selectedPortalType.name === 'publishing')">

            <!-- Is Master Portal -->
            <div class="mb-3 d-none">
              <label class="form-label text-xxs fw-500">Is Master Portal?</label>
              <div class="d-flex gap-3">
                <div class="form-check">
                  <input class="form-check-input" type="radio" id="is_master_yes" :value="true" v-model="isMaster">
                  <label class="form-check-label text-xxs" for="is_master_yes">Yes</label>
                </div>
                <div class="form-check">
                  <input class="form-check-input" type="radio" id="is_master_no" :value="false" v-model="isMaster">
                  <label class="form-check-label text-xxs" for="is_master_no">No</label>
                </div>
              </div>
            </div>



            <!-- Sub-Portals (if Master) -->
            <div class="mb-3" v-if="isMaster" :class="isEditMode ? 'd-none' : ''">
              <a class="text-primary text-xxs fw-500 text-decoration-none pointer" @click="sub_portal_modal_open">
                + Add Sub-Portals
              </a>
              <div class="text-xxs">Selected sub-portals ({{ selectedPortals.length || 0 }})</div>
            </div>

            <!-- Master Portal (if Not Master) -->
            <div class="mb-3 d-none" v-if="!isMaster">
              <label class="form-label text-xxs fw-500">Select Master Portal</label>
              <select class="form-control rounded-5 text-xxs" v-model="selectedMasterPortal">
                <option value="" disabled selected>Select master portal</option>
                <option v-for="portal in portals" :key="portal.id" :value="portal.id">{{ portal.name }}</option>
              </select>
              <p v-if="errors.master_portal" class="text-danger text-xxs">{{ errors.master_portal }}</p>
            </div>

            <!-- Public/Private -->
            <!-- Public/Private Radio Buttons -->
            <div class="d-flex gap-3 mt-2">
              <div class="form-check">
                <input class="form-check-input" type="radio" name="flexRadioDefault" id="public" value="public"
                  v-model="selectedVisibility">
                <label class="form-check-label text-xxs fw-500" for="public">
                  Public <br>
                  <span class="text-xxs text-secondary">Is the portal public?</span>
                </label>
              </div>
              <div class="form-check">
                <input class="form-check-input" type="radio" name="flexRadioDefault" id="private" value="private"
                  v-model="selectedVisibility">
                <label class="form-check-label text-xxs fw-500" for="private">
                  Private <br>
                  <span class="text-xxs text-secondary">Is the portal private?</span>
                </label>
              </div>
            </div>
          </div>

          <!-- Member Selection (Private Only) -->
          <div v-if="selectedVisibility === 'private'" class=" mt-2">
            <div class="mb-3 border rounded bg-light p-3">
              <div class="d-flex justify-content-between align-items-start gap-3">
                <div>
                  <label class="text-xxs fw-bold text-dark d-block mb-0" for="portal_is_visible">
                    Invite Only Portal
                  </label>
                  <div class="text-xxs text-muted">
                    Turn this off if you want other users to see and request access to this private portal.
                  </div>
                </div>
                <div class="form-check form-switch mt-1">
                  <input class="form-check-input" type="checkbox" id="portal_is_visible" :checked="!is_visible"
                    @change="is_visible = !$event.target.checked">
                </div>
              </div>
            </div>

            <label class="form-label text-xxs fw-500">
              <span v-if="school_domain">Add Members</span>
              <span v-else>Add Portal Members</span>
            </label>
            <div class="d-flex justify-content-between align-items-center p-2 border rounded bg-light">
              <div>
                <h6 class="text-xxs fw-bold text-uppercase mb-1 text-muted">
                  Tagged {{ school_domain ? 'Members' : 'Portal Members' }}
                </h6>
                <div class="text-xxs fw-600">
                  <i class="fas fa-users me-1"></i>
                  {{ selectedUserIds.length || 0 }} total
                </div>
              </div>

              <button type="button" class="btn btn-sm btn-primary py-1 rounded px-2 text-xxs"
                @click="add_member_modal_open">
                Add members
              </button>
            </div>

            <p v-if="errors.user_ids" class="text-danger text-xxs mt-2 mb-0">
              <i class="fas fa-exclamation-circle me-1"></i> {{ errors.user_ids }}
            </p>
          </div>

        </div>
        <div class="modal-footer">
          <button type="submit" class="btn btn-primary text-xxs rounded">{{ isEditMode ? 'Update' : 'Create' }}</button>
        </div>
      </form>
    </div>
  </div>
</div>

<!-- Add Members Modal -->
<div class="modal fade" id="portal_member_modal" tabindex="-1" aria-labelledby="portalMemberLabel" aria-hidden="true">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <p class="modal-title text-xxs fw-500" id="portalMemberLabel">Add Portal Members</p>
        <button type="button" class="btn-close text-xxs fw-500" @click="add_member_modal_close"
          aria-label="Close"></button>
      </div>
      <form @submit.prevent="add_member_modal_close">
        <div class="modal-body table-responsive">
          <table id="portalMemberTable" class="table table-striped text-xxs">
            <thead class="btn-primary text-white">
              <tr>
                <th scope="col">#</th>
                <th scope="col">First Name</th>
                <th scope="col">Last Name</th>
                <th scope="col">Email</th>
                <th scope="col" class="text-center">
                  Action
                  <span class="ms-2">
                    <input class="form-check-input" type="checkbox" id="select_all_checkbox" :checked="areAllSelected"
                      @change="toggleSelectAll" />
                  </span>
                </th>
              </tr>
            </thead>
            <tbody class="text-black">
              <tr v-for="(user, index) in users" :key="user.id">
                <th scope="row">{{ index + 1 }}</th>
                <td>{{ user.first_name }}</td>
                <td>{{ user.last_name }}</td>
                <td>{{ user.email }}</td>
                <td class="text-center">
                  <input class="form-check-input" type="checkbox" :id="'portal_member_check_' + user.id"
                    :value="user.id" v-model="selectedUserIds" />
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-light text-xxs rounded-5" @click="add_member_modal_close">Cancel</button>
          <button type="submit" class="btn btn-primary text-xxs rounded-5">Add Members</button>
        </div>
      </form>
    </div>
  </div>
</div>

<!-- Select Sub-Portals Modal -->
<div class="modal fade" id="select_portals_modal" tabindex="-1" aria-labelledby="selectPortalsLabel" aria-hidden="true">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <p class="modal-title text-xxs fw-500" id="selectPortalsLabel">Select Sub-Portals</p>
        <button type="button" class="btn-close text-xxs" @click="sub_portal_modal_close" aria-label="Close"></button>
      </div>

      <form @submit.prevent="sub_portal_modal_close">
        <div class="modal-body table-responsive">
          <table id="subPortalTable" class="table table-striped text-xxs w-100">
            <thead class="btn-primary text-white">
              <tr>
                <th scope="col">#</th>
                <th scope="col">Portal Name</th>
                <th scope="col" class="text-center">
                  Action
                  <span class="ms-2">
                    <input class="form-check-input" type="checkbox" id="select_all_subportals"
                      :checked="all_sub_portal_selected" @click="toggleSelectAllSubPortals" />
                  </span>
                </th>
              </tr>
            </thead>
            <tbody class="text-black">
              <tr v-for="(portal, index) in portals_for_selection" :key="portal.id">
                <th scope="row">{{ index + 1 }}</th>
                <td>{{ portal.name }}</td>
                <td class="text-center">
                  <input class="form-check-input" type="checkbox" :value="portal.id" v-model="selectedPortals" />
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div class="modal-footer">
          <button type="button" class="btn btn-light text-xxs rounded-5" @click="sub_portal_modal_close">Cancel</button>
          <button type="submit" class="btn btn-primary text-xxs rounded-5">Add Portals</button>
        </div>
      </form>
    </div>
  </div>
</div>
